import React, { useCallback, useEffect, useState } from 'react';
import { UserService } from '../services';
import moment from 'moment';
import VipButton from '@pages/membership/body/VipButton';
export const useUsers = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    UserService.list().then(res =>
      setUsers(res.sort((a, b) => b.createDt - a.createDt))
    );
  }, []);

  return [users, setUsers];
};

const headers = [
  {
    name: 'uid',
    label: 'uid',
    options: { filter: true, sort: true }
  },
  {
    name: 'nickName',
    label: '닉네임',
    options: { filter: true, sort: true }
  },
  {
    name: 'grade',
    label: '멤버십',
    options: { filter: true, sort: true }
  },
  {
    name: 'gradePeriod',
    label: '멤버십 기간',
    options: { filter: false, sort: false }
  },
  {
    name: 'phoneNumber',
    label: '전화번호',
    options: { filter: true, sort: true }
  },
  {
    name: 'createDt',
    label: '가입일',
    options: { filter: true, sort: true }
  }
];

const GRADE = {
  GRD_NORMAL: '일반',
  GRD_VIP: 'VIP'
};

export const useUserTable = () => {
  const [users, setUsers] = useUsers();

  const onUpdateGrade = useCallback(
    (uid, grade, gradePeriod) => {
      setUsers(prev => {
        const idx = prev.findIndex(user => user.uid === uid);
        const user = prev[idx];
        user.grade = grade;
        user.gradePeriod = gradePeriod;
        return [
          ...prev.slice(0, idx),
          user,
          ...prev.slice(idx + 1, prev.length)
        ];
      });
    },
    [setUsers]
  );

  return {
    headers,
    data: users.map(user => {
      return [
        user.uid,
        user.nickName,
        GRADE[user.grade],
        <VipButton uid={user.uid} onUpdateGrade={onUpdateGrade} />,
        user.phoneNumber,
        moment(user.createDt).format('YY.MM.DD HH:mm')
      ];
    })
  };
};

export const useUserVipPeriod = (uid, onUpdateGrade) => {
  const [user, setUser] = useState();

  useEffect(() => {
    UserService.get(uid).then(res => setUser(res));
  }, [uid]);

  if (!user) return {};

  return {
    grade: user.grade,
    gradePeriod: user.gradePeriod,
    updateGradePeriod: period => {
      onUpdateGrade(uid, 'GRD_VIP', period);
      setUser(prev => ({ ...prev, grade: 'GRD_VIP', gradePeriod: period }));
      UserService.update({ uid, grade: 'GRD_VIP', gradePeriod: period });
    },
    removeGradePeriod: () => {
      onUpdateGrade(uid, 'GRD_NORMAL', undefined);
      setUser(prev => ({
        ...prev,
        grade: 'GRD_NORMAL',
        gradePeriod: undefined
      }));
      UserService.removeGrade(user.uid);
    }
  };
};
